module.exports = __webpack_public_path__ + "img/csr11.2785ce5f.jpg";